import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useProvider } from '..';
import {
  requestExternalParties,
  selectExternalPartiesMap,
  selectExternalPartiesList,
} from '~/store/integrations';
import { selectLoading, selectErrors } from '~/store/app';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { ExternalPartyID } from '~/Models/DTO/externalParties.model';

export function useIntegrations() {
  const dispatch = useDispatch();
  const { currentProvider } = useProvider();

  const externalPartiesList = useSelector(selectExternalPartiesList);
  const externalPartiesMap = useSelector(selectExternalPartiesMap);
  const isExternalPartiesListLoading = useSelector(selectLoading(REQUEST_ACTIONS.EXTERNAL_PARTIES));
  const hasExternalPartiesListErrors = useSelector(selectErrors(REQUEST_ACTIONS.EXTERNAL_PARTIES));

  const getExternalPartiesList = bindActionCreators(requestExternalParties, dispatch);

  const hasIntegration = useCallback(
    (id: ExternalPartyID) => externalPartiesMap[id]?.enabled ?? false,
    [externalPartiesMap],
  );

  useEffect(() => {
    if (!currentProvider) {
      return;
    }
    getExternalPartiesList(currentProvider);
  }, [currentProvider?.domain]);

  return {
    hasIntegration,
    externalPartiesMap,
    externalPartiesList,
    isExternalPartiesListLoading,
    hasExternalPartiesListErrors,
  };
}
